import { ReactNode } from 'react';
import cx from 'classnames';
import Box, { BoxStyleProps } from '../Box';

import styles from './StripedBox.module.css';

interface StripedBoxProps extends BoxStyleProps {
  className?: string;
  children: ReactNode;
  color?: 'red' | 'green';
}

export default function StripedBox({
  className,
  children,
  color,
  ...otherProps
}: StripedBoxProps): JSX.Element {
  return (
    <Box
      className={cx(
        styles['base'],
        color && styles[`base--color-${color}`],
        className
      )}
      {...otherProps}
    >
      {children}
    </Box>
  );
}
